export default "__VITE_ASSET__B$OBUf2h__"